import { Fragment, useState } from 'react';
import { useAsync } from 'react-async';
import { useHistory } from 'react-router';
import {
  deleteDiscipline,
  updateDiscipline,
} from '../../../api/services/disciplineService';
import { getDiscipline } from '../../../api/services/disciplineService';
import { ResponseStatus } from '../../../components/notifications';
import { FieldInput } from '../../../components/fieldInput';
import Layout from '../../../components/layout';
import SubmitButton from '../../../components/submitButton';
import { useParams } from 'react-router-dom';
import LayoutError from '../../../components/layoutError';
import { getDisciplineGroups } from '../../../api/services/disciplineGroupService';
import DisciplineGroup from '../../../api/models/disciplineGroup';
import { selectOption } from '../../../types/selectOption';
import Select from 'react-select';
import { graySelectStyles } from '../../../common/selectStyles';

type Params = {
  id: string;
};

const fetchDiscipline = async ({ id }: any) => {
  return await getDiscipline(id);
};

const EditDisciplines = () => {
  const { id } = useParams<Params>();
  const history = useHistory();

  const [disciplineId, setDisciplineId] = useState<number | undefined>();
  const [disciplineName, setDisciplineName] = useState('');
  const [disciplineGroupId, setDisciplineGroupId] = useState<number>(0);
  const [disciplineGroupOptions, setDisciplineGroupOptions] = useState<any[]>([]);

  const fetchData = useAsync({
    promiseFn: fetchDiscipline,
    id,
    onResolve: (r) => {
      setDisciplineName(r.data.discipline.name);
      setDisciplineId(r.data.discipline.disciplineId);
      setDisciplineGroupId(r.data.discipline.disciplineGroupId ?? 0);
    },
  });

  //Get the disciplines
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const disciplineGroupsData = useAsync({
    promiseFn: getDisciplineGroups,
    onResolve: (r) => {
      const dg: DisciplineGroup[] = r.data.disciplineGroups;
      const dgOptions: selectOption[] = [];

      //Loop through the disciplines to generate the options for the multi select
      (dg.map((group) => (
        dgOptions.push({ value: group.disciplineGroupId ?? 0, label: group.name })
      )));

      setDisciplineGroupOptions(dgOptions);
    }
  });

  const saveDiscipline = async () => {
    if (!disciplineId) {
      return Promise.reject('Missing disciplineId.');
    }

    return await updateDiscipline({
      name: disciplineName,
      disciplineId: disciplineId,
      disciplineGroupId: disciplineGroupId
    });
  };

  const save = useAsync({
    deferFn: saveDiscipline,
    onResolve: () => {
      history.push('/admin/disciplines', {
        message: `"${disciplineName}" saved successfully!`,
      });
    },
  });

  const removeDiscipline = async () => {
    if (!disciplineId) {
      return Promise.reject('Missing disciplineId.');
    }

    return await deleteDiscipline(disciplineId);
  };

  const remove = useAsync({
    deferFn: removeDiscipline,
    onResolve: () => {
      history.push('/admin/disciplines', {
        message: `"${disciplineName}" removed successfully!`,
      });
    },
  });

  if (fetchData.error) return <LayoutError />;

  return (
    <Layout isLoading={fetchData.isPending}>
      <Fragment>
        <ResponseStatus state={save} />
        <ResponseStatus state={remove} />
        <div className='grid grid-cols-6 gap-6 mb-6'>
          <div className='col-span-6 sm:col-span-6'>
            <FieldInput
              name='discipline'
              label='Discipline'
              minLength={1}
              onChange={(e) => setDisciplineName(e.target.value)}
              value={disciplineName}
            />
          </div>
        </div>
        <div className='grid grid-cols-6 gap-6 mb-6'>
          <div className='col-span-6 sm:col-span-6'>
            <label className="block mb-1">Discipline Group</label>
            <div className='col-span-6 sm:col-span-6'>
              <Select
                name='discipline-group'
                onChange={(selected) => { setDisciplineGroupId(Number(selected?.value ?? 0)) }}
                value={disciplineGroupOptions.find((o: selectOption) => o.value === disciplineGroupId) || null}
                options={disciplineGroupOptions}
                getOptionLabel={(o: selectOption) => o.label}
                getOptionValue={(o: selectOption) => String(o.value)}
                styles={graySelectStyles}
              />
            </div>
          </div>
        </div>
        <div className='grid grid-cols-2'>
          <div className='grid-cols-6 text-left'>
            {/*<SubmitButton
              text='Remove'
              className='secondary'
              disabled={disciplineName.length === 0}
              spinning={remove.isPending}
              onClick={handleRemove}
            />*/}
          </div>
          <div className='grid-cols-6 text-right'>
            <SubmitButton
              text='Save Changes'
              spinning={save.isPending}
              disabled={disciplineName.length === 0}
              onClick={() => save.run()}
              className='float-right'
            />
          </div>
        </div>
      </Fragment>
    </Layout>
  );
};

export default EditDisciplines;
